import React from 'react';
import { User } from 'lucide-react';

/**
 * Tiny "edited by {name} · {relative time}" pill for a source tab in Data Entry.
 *
 * Accepts the holdingsMeta entry shape: { last_edited_by: { name, email, at } }.
 * Renders nothing if no edit has been recorded yet.
 */

const relativeTime = (iso) => {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const diffSec = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (diffSec < 60) return 'just now';
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  if (diffSec < 86400 * 30) return `${Math.floor(diffSec / 86400)}d ago`;
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const LastEditedByBadge = ({ entry, sourceId }) => {
  const editor = entry?.last_edited_by;
  if (!editor || !(editor.name || editor.email)) return null;
  const label = editor.name || (editor.email ? editor.email.split('@')[0] : 'unknown');
  const fullTitle = `${editor.name || editor.email}${editor.email ? ` (${editor.email})` : ''}\n${editor.at ? `Last edited: ${new Date(editor.at).toLocaleString()}` : ''}`;
  return (
    <span
      className="chip chip-neutral text-[9px] !py-0.5 !px-1.5 inline-flex items-center gap-1 max-w-[170px] truncate"
      title={fullTitle}
      data-testid={sourceId ? `last-edited-by-${sourceId}` : 'last-edited-by'}
    >
      <User size={9} />
      <span className="truncate">{label} · {relativeTime(editor.at)}</span>
    </span>
  );
};

export default LastEditedByBadge;
